import React from 'react';

export default function Footer() {
    return (
        <footer className="py-20 bg-espresso text-warm-pearl w-full antialiased font-sans">
            <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 font-medium">
                <div className="space-y-6">
                    <div className="flex items-center gap-3">
                        <img src="/logo.png" className="w-6 h-6" alt="Accessibility Scout Logo" />
                        <span className="font-bold text-xl tracking-tight">Accessibility Scout</span>
                    </div>
                    <p className="opacity-80 leading-relaxed max-w-xs">
                        Making web accessibility simple, actionable, and affordable for modern small businesses.
                    </p>
                </div>

                <div className="space-y-6">
                    <h2 className="font-bold text-lg opacity-50">Platform</h2>
                    <ul className="space-y-4">
                        <li><a href="#features" className="hover:text-teal transition-colors">Features</a></li>
                        <li><a href="#how-it-works" className="hover:text-teal transition-colors">How it Works</a></li>
                        <li><a href="#pricing" className="hover:text-teal transition-colors">Pricing</a></li>
                        <li><a href="#documentation" className="hover:text-teal transition-colors">Documentation</a></li>
                    </ul>
                </div>

                <div className="space-y-6">
                    <h2 className="font-bold text-lg opacity-50">Company</h2>
                    <ul className="space-y-4">
                        <li><a href="#about" className="hover:text-teal transition-colors">About Us</a></li>
                        <li><a href="#contact" className="hover:text-teal transition-colors">Contact Support</a></li>
                        <li><a href="#blog" className="hover:text-teal transition-colors">Blog</a></li>
                    </ul>
                </div>

                <div className="space-y-6">
                    <h2 className="font-bold text-lg opacity-50">Legal</h2>
                    <ul className="space-y-4">
                        <li><a href="/terms" className="hover:text-teal transition-colors">Terms of Service</a></li>
                        <li><a href="/privacy" className="hover:text-teal transition-colors">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 mt-20 pt-10 border-t border-warm-pearl/20 flex flex-col md:flex-row justify-between items-center gap-6 opacity-70 text-sm">
                <p>© {new Date().getFullYear()} Accessibility Scout. All rights reserved.</p>
                <div className="flex gap-8">
                    <span>Built with ❤️ for a more inclusive web.</span>
                </div>
            </div>
        </footer>
    );
}
